(() => {
  if (customElements.get('expandable-editorial')) return;
  customElements.define('expandable-editorial', class extends HTMLElement {
    connectedCallback() {
      this._body=this.querySelector('.expandable-editorial__body');this._button=this.querySelector('button');
      if(!this._body||!this._button)return;
      this._expanded=false;this.style.setProperty('--editorial-lines',Math.max(2,Number(this.dataset.lines)||4));
      this._render=()=>{this.toggleAttribute('data-collapsed',!this._expanded);this._button.setAttribute('aria-expanded',String(this._expanded));this._button.textContent=this._expanded?this.dataset.less:this.dataset.more;};
      this._click=()=>{this._expanded=!this._expanded;this._render();};this._button.addEventListener('click',this._click);
      this._measure=()=>{const limit=(parseFloat(getComputedStyle(this._body).lineHeight)||24)*(Number(this.dataset.lines)||4);this._button.hidden=this._body.scrollHeight<=limit+1;};
      this._render();this._measure();this._resize=new ResizeObserver(this._measure);this._resize.observe(this._body);
    }
    disconnectedCallback(){this._resize?.disconnect();this._button?.removeEventListener('click',this._click);this.removeAttribute('data-collapsed');if(this._button){this._button.hidden=true;this._button.setAttribute('aria-expanded','true');}}
  });
})();
